var ms_lineItems = document.getElementById('ms_lineItems');
if (ms_lineItems) {
  var dataset = ms_lineItems.dataset;
  var lineItems = dataset.lineItems.split(',');
  var cart = { updates: {} };
  lineItems.forEach(function(elem){
    var variants = elem.split(':');
    cart.updates[variants[0]]= variants[1];
  })
  var $cart = $.get('/cart.json').done(function(d){ return d });
  if($cart && $cart.items != cart) {
    $.post('/cart/update.json', cart).done(function(e){
    }).error(function(e) {console.log('Error:', e)});
  }
}

var gs_giftNotes = document.querySelectorAll('.gs__field>textarea');
if(gs_giftNotes) {
  for(var i = 0; i < gs_giftNotes.length; i++) {
    gs_giftNotes[i].maxLength = '255';
  }
}